import { SEARCH } from '../actions/searchActions';

export type SearchState = {
  searchQuery: string;
  searchResults: [] | null;
  showSearchBar: boolean;
  enableSearch: boolean;
};

export const searchInitialState = {
  searchQuery: '',
  searchResults: null,
  headerSearchBarDisplayed: false,
  enableSearch: false,
  searchTerms: [],
};

export const searchReducer = (state = searchInitialState, action = {}) => {
  const { payload = {} } = action;
  switch (action.type) {
    case SEARCH.UPDATE_SEARCH: {
      return {
        ...state,
        searchQuery: payload.query,
        searchResults: payload.results,
      };
    }

    case SEARCH.UPDATE_ENABLE_SEARCH: {
      return {
        ...state,
        enableSearch: payload,
      };
    }

    case SEARCH.UPDATE_SHOW_SEARCH_BAR: {
      return {
        ...state,
        showSearchBar: payload,
      };
    }

    case SEARCH.RESET_SEARCH: {
      return {
        ...state,
        searchQuery: searchInitialState.searchQuery,
        searchResults: searchInitialState.searchResults,
      };
    }

    case SEARCH.RECEIVE_SEARCH_TERMS: {
      return {
        ...state,
        searchTerms: payload,
      };
    }

    default: {
      return state;
    }
  }
};
